import Vue from "vue";
import axios from "axios";
import vSelect from "vue-select";
import VueMask from "v-mask";
import VModal from "vue-js-modal";
import VueAlert from "@vuejs-pt/vue-alert";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import svgstore from "webpack-svgstore-plugin/src/helpers/svgxhr";

const __svg__ = { path: "./assets/images/*.svg", name: "[hash].sprite.svg" };
svgstore(__svg__);

axios.defaults.baseURL = __config.base_url;
axios.interceptors.response.use(response => response.data);

Vue.config.productionTip = false;
Vue.component("v-select", vSelect);
Vue.use(VModal);
Vue.use(VueAlert);
Vue.use(VueMask);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
